module.exports = __webpack_public_path__ + "static/originalidad-2f33cb14b5a3a807c51931d49cd4e57b.png";